(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wa-mega-menu"] && !Shopify.designMode) return;
  try {
    
class WaMegaMenu extends HTMLElement {
  connectedCallback() {
    this.handle = this.dataset.waMenuHandle;
    if (!this.handle) return;

    this.panel = this.querySelector('.wa-mega-menu__panel');

    this.ensureDesktop();
    this.ensureMobile();
    this.observeHydration();
  }

  /**
   * Le header desktop ET le drawer mobile peuvent s'hydrater / se ré-afficher
   * APRÈS notre composant (data-hydration-key), ce qui efface notre
   * décoration (flèche, classes, écouteurs) ou notre entrée clonée dans le
   * drawer. On ne s'arrête donc jamais de vérifier : à chaque mutation du
   * DOM, on s'assure que tout tient toujours, et on répare sinon.
   */
  observeHydration() {
    let scheduled = false;
    this.hydrationObserver = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        this.ensureDesktop();
        this.ensureMobile();
      });
    });
    this.hydrationObserver.observe(document.body, { childList: true, subtree: true });
  }

  ensureDesktop() {
    const liveTrigger = this.findTrigger();
    if (!liveTrigger) return;

    const stillDecorated =
      liveTrigger === this.trigger &&
      liveTrigger.classList.contains('wa-mega-menu-trigger') &&
      liveTrigger.querySelector('.wa-mega-menu-trigger__arrow');

    if (stillDecorated) return;

    this.header = document.getElementById('header-component');
    this.trigger = liveTrigger;
    this.decorateTrigger();

    if (!liveTrigger.dataset.waMegaMenuBound) {
      this.bindEvents();
      liveTrigger.dataset.waMegaMenuBound = 'true';
    }

    this.updateOffset();

    if (this.dataset.waForceOpen === 'true') this.open();

    if (this.header && 'ResizeObserver' in window && !this.resizeObserver) {
      this.resizeObserver = new ResizeObserver(() => this.updateOffset());
      this.resizeObserver.observe(this.header);
    } else if (!this.resizeObserver && !this.fallbackResizeBound) {
      this.fallbackResizeBound = true;
      window.addEventListener('resize', () => this.updateOffset());
    }
  }

  slugify(text) {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
  }

  findTrigger() {
    // Structure réelle de Horizon : les liens du menu principal sont
    // rendus par le composant <header-menu> avec la classe .menu-list__link
    const links = document.querySelectorAll('#header-component .menu-list__link');
    for (const link of links) {
      if (this.slugify(link.textContent) === this.handle) return link;
    }
    return null;
  }

  decorateTrigger() {
    this.trigger.classList.add('wa-mega-menu-trigger');
    this.trigger.setAttribute('aria-haspopup', 'true');
    this.trigger.setAttribute('aria-expanded', 'false');
    this.trigger.setAttribute('aria-controls', this.id);

    // WA:START - dedupe arrow
    // Dans l'éditeur, chaque modification recrée une instance <wa-mega-menu>
    // alors que le lien (et sa flèche) posés par l'instance précédente
    // subsistent. On purge toute flèche existante avant d'en réinjecter une
    // seule, pour ne jamais accumuler de flèches en double.
    this.trigger
      .querySelectorAll('.wa-mega-menu-trigger__arrow')
      .forEach((el) => el.remove());
    // WA:END - dedupe arrow

    // Ajouté en dernier => s'affiche à droite du texte du lien
    const arrow = document.createElement('span');
    arrow.className = 'wa-mega-menu-trigger__arrow';
    arrow.innerHTML =
      '<svg viewBox="0 0 10 6" width="10" height="6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    this.trigger.appendChild(arrow);
  }

  bindEvents() {
    const open = () => this.open();
    const scheduleClose = () => {
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => this.close(), 150);
    };
    const cancelClose = () => clearTimeout(this.closeTimer);

    this.trigger.addEventListener('mouseenter', open);
    this.trigger.addEventListener('focus', open);
    this.trigger.addEventListener('mouseleave', scheduleClose);

    this.addEventListener('mouseenter', cancelClose);
    this.addEventListener('mouseleave', scheduleClose);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close();
    });
  }

  open() {
    clearTimeout(this.closeTimer);
    // WA:START - offset alignment fix
    this.updateOffset();
    // WA:END - offset alignment fix
    this.classList.add('wa-is-open');
    this.trigger.classList.add('wa-is-active');
    this.trigger.setAttribute('aria-expanded', 'true');
  }

  close() {
    if (this.dataset.waForceOpen === 'true') return;
    this.classList.remove('wa-is-open');
    this.trigger.classList.remove('wa-is-active');
    this.trigger.setAttribute('aria-expanded', 'false');
  }

  updateOffset() {
    const manualOffset = parseInt(this.dataset.waOffsetTop, 10) || 0;

    if (manualOffset > 0) {
      this.style.setProperty('--wa-mega-menu-offset-top', `${manualOffset}px`);
      return;
    }

    if (this.header) {
      // WA:START - offset alignment fix
      // position: fixed est relatif au viewport -> on cale le panneau sur le
      // bord BAS du header (barre d'annonces incluse), et non sur sa seule hauteur.
      const bottom = this.header.getBoundingClientRect().bottom;
      this.style.setProperty('--wa-mega-menu-offset-top', `${Math.max(Math.round(bottom), 0)}px`);
      // WA:END - offset alignment fix
    }
  }

  /* ---------------------------------------------------------------
     Drawer mobile : on superpose un volet plein écran (réutilise les
     classes natives .menu-drawer__submenu / .menu-drawer__back-button
     de Horizon) au-dessus du menu ouvert, avec flèche de retour.
  --------------------------------------------------------------- */

  setupMobileMediaQuery() {
    if (this.mobileQuery) return;
    this.mobileQuery = window.matchMedia('(max-width: 989px)');
    this.mobileQuery.addEventListener('change', (e) => this.handleMobileChange(e.matches));
  }

  handleMobileChange(isMobile) {
    if (isMobile) {
      this.mountInDrawer();
    } else {
      this.unmountFromDrawer();
    }
  }

  ensureMobile() {
    this.setupMobileMediaQuery();

    if (this.drawerSlot && document.contains(this.drawerSlot)) {
      // Toujours valide : on s'assure juste que le contenu est au bon endroit
      this.handleMobileChange(this.mobileQuery.matches);
      return;
    }

    // Absent ou supprimé par une ré-hydratation : on reconstruit
    this.drawerSlot = null;
    if (!this.buildDrawerEntry()) return;
    this.handleMobileChange(this.mobileQuery.matches);
  }

  findDrawerTrigger() {
    const drawerMenu = document.querySelector('.header-drawer .menu-drawer__menu');
    if (!drawerMenu) return null;

    const items = drawerMenu.querySelectorAll(
      ':scope > li > .menu-drawer__menu-item--mainlist, :scope > li > details > summary.menu-drawer__menu-item--mainlist'
    );
    for (const item of items) {
      const textEl = item.querySelector('.menu-drawer__menu-item-text') || item;
      if (this.slugify(textEl.textContent) === this.handle) return item;
    }
    return null;
  }

  buildDrawerEntry() {
    const drawerTrigger = this.findDrawerTrigger();
    if (!drawerTrigger) return false;

    if (drawerTrigger.tagName === 'SUMMARY') {
      console.warn(
        "[wa-mega-menu] Ce lien possède déjà un sous-menu natif dans le drawer ; le wa-mega-menu ne peut pas s'y superposer."
      );
      return false;
    }

    const template = document.getElementById(this.dataset.waMobileTemplate);
    const originalLi = drawerTrigger.closest('li');
    if (!originalLi || !template) return false;

    // Si une ancienne copie de CETTE instance traîne encore (cas limite), on
    // la retire avant d'en recréer une propre — scopé à son propre id pour ne
    // jamais toucher aux entrées clonées des AUTRES sections wa-mega-menu.
    originalLi.parentElement
      ?.querySelectorAll(`:scope > li.wa-mega-menu-drawer-row[data-wa-mega-menu-owner="${this.id}"]`)
      .forEach((stale) => stale.remove());

    const title = (drawerTrigger.querySelector('.menu-drawer__menu-item-text') || drawerTrigger).textContent.trim();
    const animationIndex = originalLi.style.getPropertyValue('--menu-drawer-animation-index');
    const originalLiClasses = Array.from(originalLi.classList);

    originalLi.classList.add('wa-mega-menu-original-row');

    const fragment = template.content.cloneNode(true);
    const clonedLi = fragment.querySelector('li');
    clonedLi.classList.add(...originalLiClasses);
    clonedLi.dataset.waMegaMenuOwner = this.id;

    if (animationIndex) {
      clonedLi.style.setProperty('--menu-drawer-animation-index', animationIndex.trim());
    }

    clonedLi.querySelector('[data-wa-mega-menu-summary-text] .menu-drawer__menu-item-text').textContent = title;
    const backText = clonedLi.querySelector('[data-wa-mega-menu-back-text] .menu-drawer__menu-item-text');
    if (backText) backText.textContent = title;
    clonedLi.querySelector('[data-wa-mega-menu-back-text]').setAttribute('aria-label', `Retour à ${title}`);

    originalLi.after(clonedLi);

    // Le reste (ouverture, fermeture, focus trap, scroll lock, animations) est
    // entièrement géré par le composant <header-drawer> natif via les attributs
    // on:click="header-drawer/open/submenu" et on:click="header-drawer/back".
    this.drawerSlot = clonedLi.querySelector('.wa-mega-menu__mobile-slot');

    return true;
  }

  mountInDrawer() {
    if (this.panel && this.drawerSlot && this.panel.parentElement !== this.drawerSlot) {
      this.drawerSlot.appendChild(this.panel);
    }
  }

  unmountFromDrawer() {
    if (this.panel && this.panel.parentElement !== this) {
      this.appendChild(this.panel);
    }
  }
}

if (!customElements.get('wa-mega-menu')) {
  customElements.define('wa-mega-menu', WaMegaMenu);
}

  } catch(e) { console.error(e); }
})();
})();
